import { useTranslation } from 'react-i18next';
import Telegram from '@/assets/icons/social/Telegram.svg?react';
import { brand } from '@/brand';
import { Button } from '@/shared/ui/Button';
import { AuthLayout } from './AuthLayout';

// Экран после успешной регистрации. Две презентации, и выбирает между ними не
// бренд, а факт бекенда — brand.features.emailActivation:
//   • письмо с подтверждением уходит (serious) — партнёр активируется сам по
//     ссылке, а бот-анкета ускоряет модерацию, поэтому зовём в бота;
//   • письма нет (wapclick) — RegisterForm::signup() шлёт его только при
//     isProjectPrivate(), аккаунт остаётся в статусе «Email не подтверждён» и
//     активируется руками менеджера. Единственное, что честно сказать
//     партнёру: заявку приняли, с ним свяжутся.
// Во второй ветке кнопки нет намеренно: войти до активации всё равно нельзя —
// LoginForm::isActivated() отсекает этот статус.

// Telegram-бот верификации: анкета об опыте и источниках трафика. В ?start=
// кладём email в base64url без padding'а — формат разраба бота
// (user@example.com → ?start=dXNlckBleGFtcGxlLmNvbQ).
const VERIFICATION_BOT_URL = 'https://t.me/seriouspartnersbot';

const base64UrlEncode = (s: string): string => {
  const bytes = new TextEncoder().encode(s);
  let bin = '';
  bytes.forEach((b) => {
    bin += String.fromCharCode(b);
  });
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const verificationBotUrl = (email: string): string =>
  email ? `${VERIFICATION_BOT_URL}?start=${base64UrlEncode(email)}` : VERIFICATION_BOT_URL;

type RegisterSuccessProps = {
  // Email из отправленной формы — уезжает в deep-link бота. В ветке без бота
  // не используется.
  email: string;
};

export const RegisterSuccess = ({ email }: RegisterSuccessProps) => {
  const { t } = useTranslation('auth');

  return (
    <AuthLayout title={t('register.success.title')}>
      {brand.features.emailActivation ? (
        <>
          <div className="mt-6 flex flex-col gap-4 text-content-auth-secondary sm:text-lg">
            <p>{t('register.success.received')}</p>
            <p className="font-bold">{t('register.success.botInvite')}</p>
            <p>{t('register.success.afterBot')}</p>
          </div>
          <div className="mt-8 w-full">
            <Button
              type="button"
              className="min-h-[48px] w-full !px-0"
              onClick={() =>
                window.open(verificationBotUrl(email), '_blank', 'noopener,noreferrer')
              }>
              <Telegram className="mr-2 size-5 shrink-0" />
              {t('register.success.botButton')}
            </Button>
          </div>
        </>
      ) : (
        <div className="mt-6 flex flex-col gap-4 text-content-auth-secondary sm:text-lg">
          <p>{t('register.success.received')}</p>
          <p>{t('register.success.managerContact')}</p>
        </div>
      )}
    </AuthLayout>
  );
};
